import { trans } from "@mongez/localization";
import ourStoryImage from "app/assets/images/about-us/our-story.png";

export function OurStory() {
  return (
    <section className="container px-4 py-8 lg:px-6">
      <div className="grid grid-cols-1 items-center gap-20 xl:grid-cols-2">
        <div className="flex flex-col gap-8 lg:gap-12">
          <div className="flex flex-col gap-2.5 text-[#ff6f86]">
            <h5 className="font-avenir md:text-lg font-medium tracking-wide uppercase italic lg:text-xl">
              {trans("aboutUsPage.welcomeToNanni")}
            </h5>
            <h2 className="font-playfair relative text-8xl leading-tight font-bold uppercase lg:text-[10rem] lg:leading-tight">
              <span className="relative z-10">
                {trans("aboutUsPage.ourStory")}
              </span>
              <span
                className="absolute start-1 -top-[2px] text-transparent [-webkit-text-stroke:1px_#ff6f86] lg:[-webkit-text-stroke:2px_#ff6f86]"
                aria-hidden="true"
              >
                {trans("aboutUsPage.ourStory")}
              </span>
            </h2>
          </div>

          <p className="font-avenir text-night text-xl lg:text-2xl">
            {trans("aboutUsPage.ourPassion")}
          </p>
        </div>

        <img
          src={ourStoryImage}
          alt="Our Story"
          className="mt-8 w-full rounded-2xl object-cover lg:mt-0"
        />
      </div>
    </section>
  );
}
